import React, { useState, useEffect } from "react";
import { Select, Spin, Button } from "antd";
import { TpmBar, TpmPie } from "../home/chartKit";
import { HOME_COLORS, HOME_SERIES } from "../home/homeTheme";
import "./TPMSummary1.scss";
import iconCal from "../../../Assets/Images/iconCalendar.png";
import iconCol1 from "../../../Assets/Images/iconCollection1.png";
import iconCol2 from "../../../Assets/Images/iconCollection2.png";
import snapshot1 from "../../../Assets/svg/snapshot1.svg";
import snapshot2 from "../../../Assets/svg/snapshot2.svg";
import snapshot3 from "../../../Assets/svg/snapshot3.svg";
import snapshot4 from "../../../Assets/svg/snapshot4.svg";
import snapshot5 from "../../../Assets/svg/snapshot5.svg";
import snapshot6 from "../../../Assets/svg/snapshot6.svg";
import location1 from "../../../Assets/svg/location1.svg";
import location2 from "../../../Assets/svg/location2.svg";
import location3 from "../../../Assets/svg/location3.svg";
import location4 from "../../../Assets/svg/location4.svg";
import location5 from "../../../Assets/svg/location5.svg";
import location6 from "../../../Assets/svg/location6.svg";
import ExportButton from "../../../Assets/svg/exportButton.svg";
import { httpService } from "../../../services/httpService.service";
import { months, years } from "../../../services/Enums/monthsAndYears";
import { isAuthorized } from "../../../services/authService";
import { RolesEnum } from "../../../services/rolesEnum";
import ExportModal from "../dashboard/TPMsummary/ExportModal";
import { Footer } from "antd/es/layout/layout";
import FooterComponent from "../../components/FooterComponent/FooterComponent";
import ProjectMap from "../../components/MapComponent/ProjectMap";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import ContractRangeSelectors from "../../components/ContractRamgeSelectors/ContractRangeSelectors";
import DynamicChart from "../../components/charts/DynamicChart";
import { formatChartData } from "../../components/charts/formatChartData";

const { Option } = Select;

function TpmSummary() {
  const isGuestShare = process.env.REACT_APP_API_IS_GUEST;
  const [projectData, setProjectData] = useState(null);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showGraphs, setShowGraphs] = useState(true);
  const [range, setRange] = useState({
    year: undefined,
    month: undefined,
    quarter: undefined,
  });

  const [sampleSizeCards, setSampleSizeCards] = useState({
    data: [],
    toShow: 6,
  });

  const [collapse, setCollapse] = useState({
    activityByLocation: false,
    activitySnapshot: false,
    ipDonorReporting: false,
  });
  // One muted series for every chart here (see homeTheme).
  const siteVisitsColors = HOME_SERIES;
  const redFlagsColors = HOME_SERIES;
  const [selectedProjects, setSelectedProjects] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setShowGraphs(window.innerWidth >= 500);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchProjectData = async () => {
      setLoading(true);
      try {
        if (selectedProjects && selectedProjects.length > 0) {
          // Build the repeated projectIds query params
          const projectIdsParams = selectedProjects
            .map((id) => `projectIds=${id}`)
            .join("&");

          let apiUrl = `/api/Projects/getProjectsTPMSummary?${projectIdsParams}`;

          if (range.year && range.month) {
            apiUrl += `&year=${range.year}&month=${range.month}`;
          } else if (range.year && range.quarter) {
            apiUrl += `&year=${range.year}&Quarter=${range.quarter}`;
          } else if (range.year) {
            apiUrl += `&year=${range.year}`;
          }

          httpService.get(
            apiUrl,
            (data) => {
              setProjectData(data);
              setSampleSizeCards((prev) => ({
                ...prev,
                data:
                  data?.data?.activityByLocation?.costumPropertiesCalculated ||
                  [],
              }));
              setLoading(false);
            },
            (error) => {
              console.error("Error fetching project data:", error);
              setLoading(false);
            }
          );
        } else {
          setProjectData([]);
          setSampleSizeCards((prev) => ({
            ...prev,
            data: [],
          }));
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching project data:", error);
        setLoading(false);
      }
    };

    fetchProjectData();
  }, [selectedProjects, range.year, range.month, range.quarter]);

  const siteVisitTrackingData = [
    // {
    //   type: "Data Check",
    //   value: projectData?.data?.siteVisitTracking?.dataCheck,
    // },
    // {
    //   type: "Data Collection",
    //   value: projectData?.data?.siteVisitTracking?.dataCollection,
    // },
    // {
    //   type: "Translation",
    //   value: projectData?.data?.siteVisitTracking?.translation,
    // },
    {
      type: "Report Writing",
      value: projectData?.data?.siteVisitTracking?.reportWriting,
    },
    // {
    //   type: "Reporting Completed",
    //   value: projectData?.data?.siteVisitTracking?.reportingCompleted,
    // },
    {
      type: "Report Submitted",
      value: projectData?.data?.siteVisitTracking?.reportSubmitted,
    },
    {
      type: "Report Approved",
      value: projectData?.data?.siteVisitTracking?.reportApproved,
    },
  ];

  const siteVisitsData = [
    {
      type: "Data Check",
      value: projectData?.data?.siteVisitsProgress?.dataCheck,
    },
    {
      type: "Data Collection",
      value: projectData?.data?.siteVisitsProgress?.dataCollection,
    },
    {
      type: "Planning",
      value: projectData?.data?.siteVisitsProgress?.planning,
    },
    {
      type: "Pre-Planning Phase",
      value: projectData?.data?.siteVisitsProgress?.prePlanningPhase,
    },
    {
      type: "Visit Completed",
      value: projectData?.data?.siteVisitsProgress?.visitCompleted,
    },
  ];

  const redFlagsData = [
    {
      type: "Archived",
      value: projectData?.data?.redFlagsProgress?.archived,
    },
    {
      type: "Not Addressed",
      value: projectData?.data?.redFlagsProgress?.assigned,
    },
    {
      type: "In Progress",
      value: projectData?.data?.redFlagsProgress?.inprogress,
    },
    {
      type: "On Hold",
      value: projectData?.data?.redFlagsProgress?.onhold,
    },
    {
      type: "Resolved",
      value: projectData?.data?.redFlagsProgress?.resolved,
    },
  ];

  const sampleSizeChartData = {
    labels: sampleSizeCards?.data?.map((item) => item?.name || ""),
    datasets: [
      {
        axis: "y",
        label: "",
        data: sampleSizeCards?.data?.map((item) => item?.count || 0),
        fill: false,
        backgroundColor: HOME_COLORS.brand,
        borderColor: HOME_COLORS.brand,
        barThickness: 8,
      },
    ],
  };

  const sampleSizeBarOptions = {
    responsive: true,
    indexAxis: "y",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return `Count: ${value}`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        categoryPercentage: 0.9,
        barPercentage: 0.9,
      },
    },
  };

  const fetchProjects = async () => {
    setLoading(true);
    const id = localStorage.getItem("currentContractId");
    httpService.get(
      `/api/Projects/getAll?contractId=${id}&pageNumber=1&pageSize=20000&getDeletedOnly=false`,
      (response) => {
        const projectsData = response.data.map((project) => ({
          key: project?.id,
          projectName: project?.projectName,
        }));
        setProjects(projectsData);
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching projects:", error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    if (projects.length > 0 && selectedProjects.length === 0) {
      setSelectedProjects([projects[0].key]);
    }
  }, [projects]);

  const handleRangeChange = (newValue) => {
    setRange(newValue);
  };

  // The whole section header is the toggle, so the target is the title row
  // rather than a chevron at the far right of it.
  const toggleSection = (key) =>
    setCollapse((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <Spin spinning={loading}>
      {" "}
      <div className="selectRounds">
        <div className="TPMSummaryTitle">
          Select the rounds you'd like to view on the dashboard
        </div>

        <Select
          mode="multiple"
          showSearch
          allowClear
          placeholder="Select projects"
          loading={loading}
          value={selectedProjects}
          onChange={(value) => setSelectedProjects(value)}
          style={{ width: "100%" }}
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {projects.map((project) => (
            <Option key={project.key} value={project.key}>
              {project.projectName}
            </Option>
          ))}
        </Select>
      </div>
      {selectedProjects.length > 0 && (
        <>
          <div className="tpmSummaryDiv">
            {/* Same one-line toolbar as the project TPM Summary tab. */}
            <div className="tpmTopBar">
              <div className="tpmTopBarControls" style={{ marginLeft: 0 }}>
                <ContractRangeSelectors
                  enableQuarter={true}
                  value={range}
                  onChange={handleRangeChange}
                />
                {isAuthorized([
                  RolesEnum.SystemAdmin,
                  RolesEnum.ProjectManager,
                  RolesEnum.FieldCoordinator,
                  RolesEnum.FieldTeamLeader,
                ]) && (
                  <Button
                    className="addButtonTPM"
                    onClick={() => setShowExportModal(true)}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <img src={ExportButton} alt="ExportButton" />
                    Export Dashboard
                  </Button>
                )}
                <ExportModal
                  visible={showExportModal}
                  onCancel={() => {
                    setShowExportModal(false);
                  }}
                  data={projectData}
                />
              </div>
            </div>
            {showGraphs && (
              <div className="tpmSummaryProject">
                <div className="tpmSummaryProjectName">
                  <img src={iconCal} alt="img" />
                  {range.quarter && `Quarter ${range.quarter}, `}
                  {range.year && `${range.year}`}
                  {range.month && ` ${months[range.month]}`}
                </div>
                <div className="tpmSummaryProjectInfo">
                  {/* Two equal columns instead of two charts stacked beside
                      one — the three progress charts are the same kind of
                      thing, so they read as a set at the same size. */}
                  <div className="tpmChartGrid">
                    <DynamicChart
                      title="Site Visits Progress"
                      icon={<img src={iconCol1} alt="img" />}
                      loading={loading}
                      data={formatChartData(siteVisitsData, siteVisitsColors)}
                      colors={siteVisitsColors}
                      defaultChartType="bar"
                    />
                    <DynamicChart
                      title="Site Visit Tracking Progress"
                      icon={<img src={iconCol1} alt="img" />}
                      loading={loading}
                      data={formatChartData(
                        siteVisitTrackingData,
                        siteVisitsColors
                      )}
                      colors={siteVisitsColors}
                      defaultChartType="bar"
                    />
                    {!isGuestShare && (
                      <DynamicChart
                        title="Red Flags Progress"
                        icon={<img src={iconCol2} alt="img" />}
                        loading={loading}
                        data={formatChartData(redFlagsData, redFlagsColors)}
                        colors={redFlagsColors}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            {!isGuestShare && (
              <div className="activitySnapshot">
                <div
                  className="activitySnapshotHead"
                  role="button"
                  tabIndex={0}
                  onClick={() => toggleSection("activitySnapshot")}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ")
                      toggleSection("activitySnapshot");
                  }}
                >
                  <h2 className="activitySnapshotHeader">Activity Snapshot</h2>
                  <span className="activitySnapshotToggle">
                    {collapse.activitySnapshot ? <UpOutlined /> : <DownOutlined />}
                  </span>
                </div>
                {collapse.activitySnapshot && (
                  <div className="activitySnapshotResultCard">
                    <div className="activitySnapshotCard">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.activitySnapshot
                              ?.activeIpPlanningCards
                          }
                        </h2>
                        <p className="activitySnapshotText">
                          Active IP Planning Cards
                        </p>
                      </div>
                      <div className="activitySnapshotImg">
                        <img src={snapshot1} alt="img" />
                      </div>
                    </div>
                    <div className="activitySnapshotCard">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.activitySnapshot
                              ?.activeRedFlagCards
                          }
                        </h2>
                        <p className="activitySnapshotText">
                          Active Red flag cards
                        </p>
                      </div>
                      <div className="activitySnapshotImg">
                        <img src={snapshot2} alt="img" />
                      </div>
                    </div>
                    <div className="activitySnapshotCard">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {projectData?.data?.activitySnapshot?.projectMembers}
                        </h2>
                        <p className="activitySnapshotText">Project Members</p>
                      </div>
                      <div className="activitySnapshotImg">
                        <img src={snapshot3} alt="img" />
                      </div>
                    </div>
                    <div className="activitySnapshotCard">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.activitySnapshot
                              ?.activeEnumeratorTeamCards
                          }
                        </h2>
                        <p className="activitySnapshotText">
                          Active Team Cards
                          <br />
                        </p>
                      </div>
                      <div className="activitySnapshotImg">
                        <img src={snapshot4} alt="img" />
                      </div>
                    </div>
                    <div className="activitySnapshotCard">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.activitySnapshot
                              ?.activeSiteVisitCards
                          }
                        </h2>
                        <p className="activitySnapshotText">
                          Active Site Visit Cards
                        </p>
                      </div>
                      <div className="activitySnapshotImg">
                        <img src={snapshot5} alt="img" />
                      </div>
                    </div>
                    <div className="activitySnapshotCard">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {projectData?.data?.activitySnapshot?.activeTripCards}
                        </h2>
                        <p className="activitySnapshotText">
                          Active Trip Cards
                        </p>
                      </div>
                      <div className="activitySnapshotImg">
                        <img src={snapshot6} alt="img" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            <div className="activitySnapshot">
              <div
                className="activitySnapshotHead"
                role="button"
                tabIndex={0}
                onClick={() => toggleSection("sampleSizeCards")}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ")
                    toggleSection("sampleSizeCards");
                }}
              >
                <h2 className="activitySnapshotHeader">Additional Tools</h2>
                <span className="activitySnapshotToggle">
                  {collapse.sampleSizeCards ? <UpOutlined /> : <DownOutlined />}
                </span>
              </div>
              {collapse.sampleSizeCards && (
                <TpmBar
                  data={sampleSizeChartData}
                  options={sampleSizeBarOptions}
                  height={sampleSizeCards?.data?.length * 5}
                />
              )}
            </div>
            <div className="activitySnapshot">
              <div
                className="activitySnapshotHead"
                role="button"
                tabIndex={0}
                onClick={() => toggleSection("activityByLocation")}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ")
                    toggleSection("activityByLocation");
                }}
              >
                <h2 className="activitySnapshotHeader">Activity by Location</h2>
                <span className="activitySnapshotToggle">
                  {collapse.activityByLocation ? <UpOutlined /> : <DownOutlined />}
                </span>
              </div>
              {collapse?.activityByLocation && (
                <>
                  <div className="activitySnapshotResultCard">
                    <div className="activitySnapshotCard1">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {projectData?.data?.activityByLocation?.plannedVisits}
                        </h2>
                        <p className="activitySnapshotText">Target Visits</p>
                      </div>
                      <div className="activitySnapshotImg1">
                        <img src={location1} alt="img"></img>
                      </div>
                    </div>
                    {!isGuestShare && (
                      <div className="activitySnapshotCard1">
                        <div className="activitySnapshotNumber">
                          <h2 className="activitySnapshotNumber1">
                            {
                              projectData?.data?.activityByLocation
                                ?.postponedCards
                            }
                          </h2>
                          <p className="activitySnapshotText">
                            Postponed Cards
                          </p>
                        </div>
                        <div className="activitySnapshotImg1">
                          <img src={location2} alt="img"></img>
                        </div>
                      </div>
                    )}
                    <div className="activitySnapshotCard1">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.activityByLocation
                              ?.completedVisits
                          }
                        </h2>
                        <p className="activitySnapshotText">Completed Visits</p>
                      </div>
                      <div className="activitySnapshotImg1">
                        <img src={location3} alt="img"></img>
                      </div>
                    </div>
                    <div className="activitySnapshotCard1">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.activityByLocation
                              ?.completedBeneficiaryInterviews
                          }{" "}
                          <span style={{ fontSize: " 20px" }}>completed</span>
                        </h2>
                        <p className="activitySnapshotText">
                          Beneficiary Interviews
                        </p>
                      </div>
                      <div className="activitySnapshotImg1">
                        <img src={location4} alt="img"></img>
                      </div>
                    </div>
                    <div className="activitySnapshotCard1">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.activityByLocation
                              ?.completedClientsInterviews
                          }
                          <span style={{ fontSize: " 20px" }}>completed</span>
                        </h2>
                        <p className="activitySnapshotText">
                          Clients Interviews
                        </p>
                      </div>
                      <div className="activitySnapshotImg1">
                        <img src={location5} alt="img"></img>
                      </div>
                    </div>
                    <div className="activitySnapshotCard1">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.activityByLocation
                              ?.completedObservationInterviews
                          }
                          <span style={{ fontSize: " 20px" }}>completed</span>
                        </h2>
                        <p className="activitySnapshotText">
                          Observation Checklist
                        </p>
                      </div>
                      <div className="activitySnapshotImg1">
                        <img src={location6} alt="img"></img>
                      </div>
                    </div>
                    {/* {sampleSizeCards?.data
                      ?.slice(0, sampleSizeCards?.toShow)
                      ?.map((item, index) => (
                        <SampleSizeCard
                          key={index}
                          name={item?.name}
                          count={item?.count}
                        />
                      ))}

                    <div className="d-flex justify-content-center w-100">
                      {sampleSizeCards?.data?.length >
                        sampleSizeCards?.toShow && (
                        <p
                          className="activitySnapshotText d-flex align-items-center gap-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSampleSizeCards((prev) => ({
                              ...prev,
                              toShow: prev.toShow + 6,
                            }));
                          }}
                        >
                          Load More <DownOutlined />
                        </p>
                      )}
                    </div> */}
                  </div>
                  <ProjectMap data={projectData}></ProjectMap>
                </>
              )}
            </div>
            {!isGuestShare && (
              <div className="activitySnapshot">
                <div
                  className="activitySnapshotHead"
                  role="button"
                  tabIndex={0}
                  onClick={() => toggleSection("ipDonorReporting")}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ")
                      toggleSection("ipDonorReporting");
                  }}
                >
                  <h2 className="activitySnapshotHeader">
                    IP/Donor Reporting Status Snapshot
                  </h2>
                  <span className="activitySnapshotToggle">
                    {collapse.ipDonorReporting ? <UpOutlined /> : <DownOutlined />}
                  </span>
                </div>
                {collapse.ipDonorReporting && (
                  <div className="donorsDiv">
                    <div className="donorsLeft">
                      <div className="donorsCardsContainer">
                        <div className="donorsCard">
                          {" "}
                          <div className="activitySnapshotNumber">
                            <h2 className="activitySnapshotNumber1">
                              {" "}
                              {
                                projectData?.data?.ipDonorReporting
                                  ?.completedFieldTeamReporting
                              }
                            </h2>
                            <p className="activitySnapshotText">
                              Field Team Reports-Completed
                            </p>
                          </div>
                          <div className="activitySnapshotImg1">
                            <img src={location1} alt="img"></img>
                          </div>
                        </div>{" "}
                        {/* <div className="donorsCard">
                  {" "}
                  <div className="activitySnapshotNumber">
                    <h2 className="activitySnapshotNumber1">
                      {
                        projectData?.data?.ipDonorReporting
                          ?.awaitingFieldReportings
                      }
                    </h2>
                    <p className="activitySnapshotText">
                      IP/Donor reports - Awaiting Field
                    </p>
                  </div>
                  <div className="activitySnapshotImg1">
                    <img src={location2} alt="img"></img>
                  </div>
                </div>{" "} */}
                        <div className="donorsCard">
                          {" "}
                          <div className="activitySnapshotNumber">
                            <h2 className="activitySnapshotNumber1">
                              {
                                projectData?.data?.ipDonorReporting
                                  ?.otherStatusesFieldTeamReporting
                              }
                            </h2>
                            <p className="activitySnapshotText">
                              Field Team Reports-Other Statuses
                            </p>
                          </div>
                          <div className="activitySnapshotImg1">
                            <img src={location5} alt="img"></img>
                          </div>
                        </div>{" "}
                        <div className="donorsCard">
                          {" "}
                          <div className="activitySnapshotNumber">
                            <h2 className="activitySnapshotNumber1">
                              {
                                projectData?.data?.ipDonorReporting
                                  ?.completedIPDonorReports
                              }
                            </h2>
                            <p className="activitySnapshotText">
                              IP/Donor Reports - Completed
                            </p>
                          </div>
                          <div className="activitySnapshotImg1">
                            <img src={location6} alt="img"></img>
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                    <div className="donorsRight w-100">
                      {" "}
                      <div className="donorListLeft">
                        <h1 className="donorListHeaderText">
                          IP/Donor Reports
                        </h1>
                      </div>
                      <div className="donorListRight">
                        <h2 className="donorListHeader2Text">
                          Last 3 Uploaded
                        </h2>
                      </div>
                      <ul className="p-0 ">
                        {projectData?.data?.ipDonorReporting?.ipDonorReports.map(
                          (report, index) => (
                            <li key={index} className="donorListItem">
                              IP/Donor Report - {report.ipName} -{" "}
                              {report.location} - Report {report.reportNumber}
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* {!isGuestShare && (
              <div className="activitySnapshot">
                <h2 className="activitySnapshotHeader">Tasks Overview</h2>
                <div className="donorsDiv">
                  {" "}
                  {showGraphs && (
                    <div className="tpmSummaryCollectionGoal">
                      <div className="collectionGoalHeader">
                        <img src={iconCol1} alt="img" /> Tasks
                      </div>
                      <div className="collectionGoalProgress">
                        <center>
                          {loading ? (
                            <div>Loading...</div>
                          ) : createPieData(tasksData, siteVisitsColors) ? (
                            <div style={{ maxWidth: "400px", width: "100%" }}>
                              <TpmPie
                                data={createPieData(
                                  tasksData,
                                  siteVisitsColors
                                )}
                                options={pieOptions}
                              />
                            </div>
                          ) : (
                            <Empty description="No data available" />
                          )}
                        </center>
                      </div>
                    </div>
                  )}
                  <div className="taskRight">
                    <div className="activityTaskCard">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.tasksOverviewResponse
                              ?.assignedTasks
                          }
                        </h2>
                        <p className="activitySnapshotText">Assigned Tasks</p>
                      </div>
                      <div className="activitySnapshotImg">
                        <img src={snapshot1} alt="img"></img>
                      </div>
                    </div>
                    <div className="activityTaskCard">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.tasksOverviewResponse
                              ?.acceptedTasks
                          }
                        </h2>
                        <p className="activitySnapshotText">Accepted Tasks</p>
                      </div>
                      <div className="activitySnapshotImg">
                        <img src={snapshot1} alt="img"></img>
                      </div>
                    </div>
                    <div className="activityTaskCard">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.tasksOverviewResponse
                              ?.onHoldTasks
                          }
                        </h2>
                        <p className="activitySnapshotText">On Hold Tasks</p>
                      </div>
                      <div className="activitySnapshotImg">
                        <img src={snapshot1} alt="img"></img>
                      </div>
                    </div>
                    <div className="activityTaskCard">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.tasksOverviewResponse
                              ?.archivedTasks
                          }
                        </h2>
                        <p className="activitySnapshotText">Archived Tasks</p>
                      </div>
                      <div className="activitySnapshotImg">
                        <img src={snapshot3} alt="img"></img>
                      </div>
                    </div>
                    <div className="activityTaskCard">
                      <div className="activitySnapshotNumber">
                        <h2 className="activitySnapshotNumber1">
                          {
                            projectData?.data?.tasksOverviewResponse
                              ?.completedTasks
                          }
                        </h2>
                        <p className="activitySnapshotText">Completed Tasks</p>
                      </div>
                      <div className="activitySnapshotImg">
                        <img src={snapshot5} alt="img"></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )} */}
          </div>
          <Footer>
            <FooterComponent></FooterComponent>
          </Footer>
        </>
      )}
    </Spin>
  );
}

export default TpmSummary;
